import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseComponent } from 'src/app/lib/base-component';

@Component({
  selector: 'app-registration-doctor',
  templateUrl: './registration-doctor.component.html',
  styleUrls: ['./registration-doctor.component.scss'],
})
export class RegistrationDoctorComponent extends BaseComponent implements OnInit {
  @Output() changeModeEvent = new EventEmitter<string[]>();
  value: string[]
  

  constructor() { 
    super()
  }

  ngOnInit() {
  }

  registrationMode(mode: string) {
    this.value = [mode,'form']
    this.emit()
  } 
  
  emit(){
    this.changeModeEvent.emit(this.value);
  }

}
